import { AxiosInstance } from "axios";

const LEGAL_INFORMATION_PREFIX = "/legal-information";

export async function getPrivacyPolicy(http: AxiosInstance) {
	const response = await http.get(LEGAL_INFORMATION_PREFIX + "/privacy-policy");
	return response.data;
}

export async function getTermsAndConditions(http: AxiosInstance) {
	const response = await http.get(
		LEGAL_INFORMATION_PREFIX + "/terms-and-conditions"
	);
	return response.data;
}
